import { render, staticRenderFns } from "./logisticsTracking.vue?vue&type=template&id=6600f576&scoped=true&"
import script from "./logisticsTracking.vue?vue&type=script&lang=js&"
export * from "./logisticsTracking.vue?vue&type=script&lang=js&"
import style0 from "./logisticsTracking.vue?vue&type=style&index=0&id=6600f576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600f576",
  null
  
)

export default component.exports